<template>
    <form-row title="Notes" :label_align_top="true">
        <div class="w-full flex flex-col">
            <input-textarea
                name="utilities_notes"
                v-model="commercial.utilities_notes"
            />
        </div>
    </form-row>
</template>

<script>
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        read_only: { default: false },
        commercial: {},
    },
}
</script>
